import { render, staticRenderFns } from "./PDFCanvasV2.vue?vue&type=template&id=8d2b0f20&scoped=true&"
import script from "./PDFCanvasV2.vue?vue&type=script&lang=js&"
export * from "./PDFCanvasV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2b0f20",
  null
  
)

export default component.exports